module.exports = __webpack_public_path__ + "static/img/banner.6dff519.png";


//////////////////
// WEBPACK FOOTER
// ./static/companyinfo/banner.png
// module id = 5nJn
// module chunks = 1